import React from 'react';

const MatchbacksIcon = (props: any) => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="6" cy="8.5" r="5" strokeWidth="1.5" />
      <circle cx="11" cy="8.5" r="5" strokeWidth="1.5" strokeDasharray="1.6 1.6" />
    </svg>
  );
};

export default MatchbacksIcon;
